<template>
  <section
    class="nav"
    :class="{
      'active' : showHeader
    }"
  >
    <booking-vehicle
      v-if="showHeader"
      is-mobility
      is-header
    />
  </section>
</template>
<script>

import BookingVehicle from '../../Booking/BookingVehicle'

export default {
  components: {
    BookingVehicle,
  },
  computed: {
    showHeader() {
      return this.$store.state.stepping.header
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../../../_src/sass/config/vars';
@import '../../../../../_src/sass/config/mixins';
@import '../../../../../_src/sass/config/responsive';

.nav {
  display: none;

  &.active {
    display: flex;

    .booking-container {
      @include teq-breakpoint($large) {
        border: none;
        bottom: auto;
        left: 50%;
        max-width: 1130px;
        transform: translateX(-50%);
      }
    }
  }

  @include teq-breakpoint($medium) {
    border-top: 1px solid #ddd;
    display: flex;
  }
}
</style>
